import { Breadcrumbs, Typography, Link, styled } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { useIndicadoresServicosObrasViewModel } from "../../viewModels/indicadores_servicos_obras_view_model";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { Header } from "./components/header";
import { useMemo } from "react";

import AlertError from "../../../../../common/components/alert_error";
import dayjs from "dayjs";

/**
 * Table style
 */

const TableContainer = styled('div')({
  '::-webkit-scrollbar': {
    width: '0.50rem',
    height: '0.50rem',
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: '#f58634',
  },
});

/**
 * IndicadoresServicosObras
 */

export const IndicadoresServicosObras = () => {
  const viewModel = useIndicadoresServicosObrasViewModel();
  const { filteredIndicadoresServicosObra, handleGoToAreaChecklistServico } = viewModel;

  const columns = useMemo(() => {
    if (filteredIndicadoresServicosObra === undefined) return <></>;
    if (filteredIndicadoresServicosObra.areas.length === 0) return <></>;
    return filteredIndicadoresServicosObra.areas.map((area, index) => {
      return (
        <th
          key={index}
          className="border border-[#90C090] dark:border-[#707070] px-2 py-2"
          style={{ width: '9rem', height: '5rem' }}>
          <div className="size-full text-[0.70rem] font-normal flex flex-col justify-center items-center">
            {area.descricao}
          </div>
        </th>
      );
    });
  }, [
    filteredIndicadoresServicosObra,
  ]);

  const data = useMemo(() => {
    if (filteredIndicadoresServicosObra === undefined) return <></>;
    if (filteredIndicadoresServicosObra.areas.length === 0) return <></>;
    if (filteredIndicadoresServicosObra.checklists.length === 0) return <></>;
    return filteredIndicadoresServicosObra.checklists.map(
      (item) => {
        if (filteredIndicadoresServicosObra === undefined) return <></>;
        return (
          <tr key={item.idChecklistServico}>
            <td className="w-[30rem] h-[3rem] bg-[#f0f0f0] dark:bg-[#2c2c2c] border border-[#90C090] dark:border-[#707070] sticky left-0 z-50 ">
              <div className="size-full text-black dark:text-white text-[0.7rem] text-semi flex flex-col justify-center px-2">
                {item.codigo} - {item.descricao} {item.revisao !== null && `(Rev. ${item.revisao})`}
              </div>
            </td>
            {
              filteredIndicadoresServicosObra.areas.map((area, index) => {
                const servico = area.servicos.find((servico) => servico.idChecklistServico === item.idChecklistServico);
                const statusArea = servico?.status;
                const idObraChecklistServico = servico?.idObraChecklistServico ?? null;
                const data = servico && servico.data ? dayjs(servico.data).local().format('DD/MM/YYYY') : null;
                return (
                  <td
                    key={index}
                    className="h-[3rem] border border-[#90C090] dark:border-[#707070]">
                    <div className="size-full flex text-sm flex flex-col justify-center items-center">
                      {
                        statusArea === 0
                          ? (
                            <div
                              className="size-full flex flex-col justify-center items-center bg-[#4d93d9] text-white text-center text-[0.70rem] font-bold">
                              Checklist não aplicável a esta área
                            </div>
                          )
                          : (
                            statusArea === 1
                              ? (
                                <div
                                  onMouseDown={(e) => {
                                    if (e.button === 1) {
                                      handleGoToAreaChecklistServico(area.idObraAreaChecklist, idObraChecklistServico, true);
                                    } else {
                                      handleGoToAreaChecklistServico(area.idObraAreaChecklist, idObraChecklistServico, e.ctrlKey);
                                    }
                                    e.preventDefault();
                                  }}
                                  className="size-full flex flex-col justify-center items-center bg-[#ff2222] hover:bg-[#dd0000] text-white text-center text-[0.70rem] font-bold cursor-pointer">
                                  Serviço não iniciado
                                </div>
                              )
                              : (statusArea === 2
                                ? (
                                  <div
                                    onMouseDown={(e) => {
                                      if (e.button === 1) {
                                        handleGoToAreaChecklistServico(area.idObraAreaChecklist, idObraChecklistServico, true);
                                      } else {
                                        handleGoToAreaChecklistServico(area.idObraAreaChecklist, idObraChecklistServico, e.ctrlKey);
                                      }
                                      e.preventDefault();
                                    }}
                                    className="size-full flex flex-col justify-center items-center bg-[#ffff00] hover:bg-[#cccc00] text-black text-center text-[0.70rem] font-bold cursor-pointer">
                                    <div>Serviço iniciado</div>
                                    <div>{data}</div>
                                  </div>
                                )
                                : (<div
                                  onMouseDown={(e) => {
                                    if (e.button === 1) {
                                      handleGoToAreaChecklistServico(area.idObraAreaChecklist, idObraChecklistServico, true);
                                    } else {
                                      handleGoToAreaChecklistServico(area.idObraAreaChecklist, idObraChecklistServico, e.ctrlKey);
                                    }
                                    e.preventDefault();
                                  }}
                                  className="size-full flex flex-col justify-center items-center bg-[#92d050] hover:bg-[#7ab83a] text-black text-center text-[0.70rem] font-bold cursor-pointer">
                                  <div>Serviço encerrado</div>
                                  <div>{data}</div>
                                </div>
                                )
                              )
                          )
                      }
                    </div>
                  </td>
                );
              })
            }
          </tr>
        );
      }
    );
  }, [
    filteredIndicadoresServicosObra,
    handleGoToAreaChecklistServico,
  ]);

  return (
    <>
      {/**
        * ObrasTopBar
        */}

      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObraHeaderInfo}
        onBack={viewModel.handleBack}>
      </ObrasTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Indicadores de Serviços da Obra
          </Typography>
        </Breadcrumbs>

        {/**
          * ObrasTopHeader
          */}

        <ObrasTopHeader
          title="Indicadores de Serviços da Obra"
          selectedObra={viewModel.selectedObraHeaderInfo ?? null}
          onReload={viewModel.handleReload}
        />

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  area={viewModel.filters.area}
                  atividades={viewModel.filters.atividades}
                  status={viewModel.filters.status}
                  checklistServicoDropdown={viewModel.checklistServicosDropdown}
                  onChangeArea={viewModel.handleAreaChange}
                  onChangeAtividades={viewModel.handleAtividadesChange}
                  onChangeStatus={viewModel.handleStatusChange}
                  onClear={viewModel.handleClearFilters}
                />

                <TableContainer className="w-full min-h-[35rem] max-h-[45rem] overflow-auto bg-white dark:bg-[#2c2c2c] border border-[#90C090] dark:border-[#707070]">
                  <div className="size-full">
                    {
                      viewModel.filteredIndicadoresServicosObra &&
                      <table className="table-fixed w-full text-black dark:text-white border-separate border-spacing-0 border border-[#90C090] dark:border-[#707070]">
                        <thead className="bg-[#f0f0f0] dark:bg-[#2c2c2c] border border-[#90C090] dark:border-[#707070] text-black dark:text-white z-50">
                          <tr className="bg-[#f0f0f0] dark:bg-[#2c2c2c] border border-[#90C090] dark:border-[#707070] sticky top-0 z-50">
                            <th
                              className="w-[20rem] border border-[#90C090] dark:border-[#707070] px-2 py-2">
                              <div className="text-sm flex flex-col justify-center items-center">
                                Atividades
                              </div>
                            </th>
                            {columns}
                          </tr>
                        </thead>
                        <tbody>
                          {data}
                        </tbody>
                      </table>
                    }
                  </div>
                </TableContainer>
              </>
            )
        }
      </div>

      {/**
        * Obra Informacoes Modal
        */}

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />
    </>
  );
}